/**
 * @generated SignedSource<<3dd0fa21ac79f2c74acb2d2dab710435>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatedAtColumn_FeedbackFragment$data = {
  readonly createdAt: string;
  readonly " $fragmentType": "CreatedAtColumn_FeedbackFragment";
};
export type CreatedAtColumn_FeedbackFragment$key = {
  readonly " $data"?: CreatedAtColumn_FeedbackFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatedAtColumn_FeedbackFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatedAtColumn_FeedbackFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "FeedbackV2",
  "abstractKey": null
};

(node as any).hash = "a7e8545b8efd4159f0ad8f5002ec4d33";

export default node;
